module.exports = __webpack_public_path__ + "static/media/logo_bankpopulaire.67957a8c.jpg";